/* eslint-disable */
import api, { BASE_URL } from "../api";

const state = {
  loading: false,
  pageNum: 0,
  numPages: 0,
  prev: null,
  next: null,
  count: null,
  documents: {},
  createError: null
};

// getters
const getters = {};

// actions
const actions = {
  initDocuments: context => {
    context.commit("SET_LOADING", true);
    api(context)
      .get(`${BASE_URL}/documents/admin/documents/`)
      .then(response => response.data)
      .then(data => {
        context.commit("DEFAULT_API_RESPONSE", data);
      })
      .catch(error => {
        console.log(error);
        console.log("ERROR");
      })
      .finally(() => {
        context.commit("SET_LOADING", false);
      });
  },
  nextDocuments: context => {
    context.commit("SET_LOADING", true);
    api(context)
      .get(context.state.next)
      .then(response => response.data)
      .then(data => {
        context.commit("DEFAULT_API_RESPONSE", data);
      })
      .catch(error => {
        console.log(error);
        console.log("ERROR");
      })
      .finally(() => {
        context.commit("SET_LOADING", false);
      });
  },
  prevDocuments: context => {
    context.commit("SET_LOADING", true);
    api(context)
      .get(context.state.prev)
      .then(response => response.data)
      .then(data => {
        context.commit("DEFAULT_API_RESPONSE", data);
      })
      .catch(error => {
        console.log(error);
        console.log("ERROR");
      })
      .finally(() => {
        context.commit("SET_LOADING", false);
      });
  },
  activateSecureUrl: (context, url) => {
    api(context)
      .get(`${BASE_URL}${url}`)
      .then(response => response.data)
      .then(data => {
        window.open(data.url, "_blank");
        return data.url;
      })
      .catch(error => {
        console.log(error);
        console.log("ERROR");
      });
  }
};

// mutations
const mutations = {
  DEFAULT_API_RESPONSE(state, data) {
    if (!!data.count) {
      state.documents = data.results;
      state.pageNum = data.page_num;
      state.numPages = data.num_pages;
      state.count = data.count;
      state.next = data.next;
      state.prev = data.previous;
    } else {
      state.documents = data;
      state.pageNum = 0;
      state.numPages = 0;
      state.count = data.length;
      state.next = null;
      state.prev = null;
    }
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  }
};

export default { namespaced: true, state, getters, actions, mutations };
